import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectOrigen } from 'sharedComponents/select'

const OrigenFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='ORIGEN' htmlFor='select-origen' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='origen'>
          {({ field }) => <SelectOrigen {...field} id='select-origen' isInvalid={iError && iTouched} disabled={fIsSubmitting} />}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(OrigenFormGroup)
